import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import WrapperPage from "../../components/WrapperPage";
import TextAnswer from "./components/TextAnswer";
import RatingAnswer from "./components/RatingAnswer";
import DropDownAnswer from "./components/DropDownAnswer";
import BaseButton from "../../components/BaseButton";
import useViewController from "./viewController";
import BaseSpinner from "../../components/BaseSpinner";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.scss";
import CardView from "../InsightQuestionnaireFormPage/components/CardView";
import InsightFormProtect from "../../hocs/InsightFormProtect";
import ROUTES from "../../utils/routes.js";
import config from "../../config";
import BlankFormHead from "../InsightQuestionnaireFormPage/components/BlankFormHead";
import useModalActions from "../../hooks/useModalActions";
import { MODAL_TYPES } from "../../utils/emitter";
import BlankRecommendationModal from "../../modals/BlankRecommendationModal";

export default InsightFormProtect(
  function InsightQuestionnaireAnswersBothPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const { questions, questionsLoading, questionInfo, questionName } =
      useViewController();
    const { openModal } = useModalActions();

    const noUserAnswer = useMemo(() => {
      return questions.every((question) => !question.userAnswer?.value);
    }, [questions]);

    return (
      <div className="insight-questionnaire-form-page centering-page">
        <BlankRecommendationModal />
        <WrapperPage backBtn burgerMenu>
          {questionsLoading ? (
            <div className="insight-questionnaire-form-page__loader">
              <BaseSpinner />
            </div>
          ) : (
            <>
              {questionInfo ? (
                questionInfo.formType === "BLANK" ? (
                  // пустая анкета (Figma 11691-46635): карточка с бабочкой сверху +
                  // название под ней по центру — как у обычных карт (было только текст)
                  <BlankFormHead name={questionName} />
                ) : (
                  <CardView
                    imgUrl={`${config.staticApiUrl}${questionInfo.question?.cardUrl}`}
                    title={questionName}
                  />
                )
              ) : null}
              <div className="insight-questionnaire-form-page__questions">
                {questions.map((question) => {
                  if (question.type === "text") {
                    return (
                      <TextAnswer
                        question={question}
                        value={question.value}
                        title={question.title}
                        key={question.number}
                        number={question.number}
                        name={`question-${question.number}`}
                      />
                    );
                  }
                  if (question.type === "rating") {
                    return (
                      <RatingAnswer
                        question={question}
                        value={question.value}
                        title={question.title}
                        key={question.number}
                        number={question.number}
                        name={`question-${question.number}`}
                      />
                    );
                  }
                  if (question.type === "dropdown") {
                    return (
                      <DropDownAnswer
                        question={question}
                        value={question.value}
                        title={question.title}
                        key={question.number}
                        number={question.number}
                        name={`question-${question.number}`}
                      />
                    );
                  }
                  return null;
                })}
              </div>

              <div className="insight-questionnaire-form-page__action-buttons">
                <BaseButton
                  onClick={() => {
                    // пустая анкета: своя РЕКОМЕНДАЦИЯ; для ещё не заполнившего
                    // свою половину — вторая версия текста (Figma 11925-49089)
                    if (questionInfo?.formType === "BLANK") {
                      openModal(MODAL_TYPES.BLANK_RECOMMENDATION, {
                        invited: noUserAnswer,
                      });
                      return;
                    }
                    noUserAnswer
                      ? navigate(ROUTES.INSIGHT_RECOMMENDATION(questionInfo.id))
                      : navigate(ROUTES.INSIGHT_RECOMMENDATION_PAIR);
                  }}
                >
                  {t("insight_questionnaire_form_page.recommendations")}
                </BaseButton>
                {noUserAnswer ? (
                  <BaseButton
                    unfilledGray
                    onClick={() =>
                      navigate(
                        ROUTES.INSIGHT_QUESTIONNAIRE_FORM_PAGE(questionInfo.id),
                        {
                          state: {
                            formId: questionInfo.id,
                            from: location.pathname,
                          },
                        }
                      )
                    }
                  >
                    {t("insight_questionnaire_form_page.fill")}
                  </BaseButton>
                ) : (
                  <BaseButton
                    unfilledGray
                    onClick={() => navigate(ROUTES.INSIGHT_QUESTIONNAIRE_PAGE)}
                  >
                    {t("insight_questionnaire_form_page.close")}
                  </BaseButton>
                )}
              </div>
            </>
          )}
        </WrapperPage>
      </div>
    );
  }
);
